globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.DataTable = (function(){

  DataTable.selector = '[data-plugin="limitless.datatable"]';

  DataTable.initAll = function($html) {
    $html.find(DataTable.selector).each(function() {
      new DataTable($(this)).init();
    })
  }

  function DataTable($html) {
    this.$html = $html;
    this.defaults = {
      orderable: true,
      order: [],
      paginate: true,           // Top right 'Show N entries dopdown & Bottom right N pages'
      searching: true,          // Top left search bar
      bInfo: true,              // Bottom left 'Show N of N entries'
      select: true,
      autoWidth: true,
      language: {
          search: '_INPUT_',    // You can add HTML here: '<span>Rechercher:</span> _INPUT_'
          searchPlaceholder: 'Rechercher...',
          lengthMenu: '_MENU_', // You can add HTML here: '<span>Show:</span> _MENU_'
          paginate: { 'first': 'Premier', 'last': 'Dernier', 'next': '&rarr;', 'previous': '&larr;' },
          info: "Affichage des entrées _START_ à _END_ sur _TOTAL_",
      },
    }
  }

  DataTable.prototype = {
    init: function(){
      var DataTable = this,
          options   = this.$html.data('plugin-options') || {};

      if(options.selectHeaders && options.selectHeaders.length) {
        DataTable.addHeaderButtons(options);
      }

      DataTable.$html.DataTable(
        $.extend({}, DataTable.defaults, options, true)
      );

      DataTable.initSelects();
    },
    addHeaderButtons: function(options){
      var DataTable  = this,
          $selectRow = $('<tr>', { role: "row", class: "select-row" })

      options.initComplete = function () {
        $(this.api().table().header()).append($selectRow)

        var colSize = this.api().columns().count();
        for (col = 0; col < colSize; col++) {
          $selectRow.append($('<th>', {id: `select-col-${col}`}));
        }

        this.api().columns(options.selectHeaders).every(function (headerIndex) {
          var column = this;
          var select = $('<select class="allow-clear" placeholder="Selectionnez une valeur..." data-plugin="limitless.selects.single"><option value=""></option></select>')
              .appendTo($(`#select-col-${headerIndex}`))
              .on('change', function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());
                  column.search(val ? '^' + val + '$' : '', true, false).draw();
              });

          column.data().unique().sort().each(function (d, j) {
            select.append('<option value="' + d + '">' + d + '</option>');
          })
        });
      }
    },
    initSelects: function(){
      var DataTable = this,
          $nbOfPagesSelect = DataTable.$html.parent().find(".dataTables_length select")

      if($nbOfPagesSelect.length) { new appCustomerSpace.LimitlessPlugins.Selects.Single($nbOfPagesSelect); }

      DataTable.$html.find(appCustomerSpace.LimitlessPlugins.Selects.Single.selector).each(function() {
        new appCustomerSpace.LimitlessPlugins.Selects.Single($(this));
      });
    }
  }

  return DataTable;
})();
